import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IChartFooterProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import ChartTableToggle from "../tableToggle";
import Card from "../../../card";
import Text from "../../../text";

const ChartFooter: FC<IChartFooterProps> = ({
    isTableToggleVisible = false,
    isRefetching = false,
    isDivided = false,
    customLocalize,
    customTheme,
    children,
    note
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const {
        actions: actionsDynamicStyle
    } = useStyles({
        spaces
    });

    const text = isRefetching ? localize("chart-updating") : note;

    const renderNote = () => {
        if(!text) {
            return <View
                style={stylesheet.note}
            />;
        }

        return <Text
            customTheme={customTheme}
            style={stylesheet.note}
            variant="bodySmallSize"
            color="low"
        >
            {text}
        </Text>;
    };

    const renderActions = () => {
        if(!children && !isTableToggleVisible) {
            return null;
        }

        return <View
            style={[
                stylesheet.actions,
                actionsDynamicStyle
            ]}
        >
            {children}
            {
                isTableToggleVisible ?
                    <ChartTableToggle
                        customLocalize={customLocalize}
                        customTheme={customTheme}
                    />
                :
                    null
            }
        </View>;
    };

    return <Card.Footer
        customTheme={customTheme}
        isDivided={isDivided}
        align="between"
    >
        {renderNote()}
        {renderActions()}
    </Card.Footer>;
};
export default Object.assign(ChartFooter, {
    cardPart: "footer" as const
});
